export default function SectionAbout() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[960px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              关于我们
            </h2>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <div className="space-y-5 text-sm text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">777影院</strong>（777影院午夜伦不卡）是一个致力于为广大影迷提供
                高清流畅在线观影体验的影视内容聚合平台。我们深知每一位观众对于画质和播放速度的追求，
                因此从建站之初就将"高清不缓冲"作为核心服务标准。
              </p>
              <p>
                平台收录了超过六万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
                从院线新片到经典老片，从国产热播剧到海外高分剧集，从热门综艺到小众纪录片，
                777影院致力于满足不同观众群体的多元观影需求。
              </p>
              <p>
                我们的编辑团队每日精心筛选和更新内容，确保片源的新鲜度和品质。
                技术团队不断优化播放体验，采用全网CDN加速和智能画质切换技术，
                让每一位用户都能享受流畅顺滑的观影过程。777影院坚持纯净观影理念，
                全站资源免费开放，无需注册，即点即看。
              </p>
              <div className="flex flex-wrap gap-4 pt-4 border-t border-background-200/60">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-shield-check-line text-accent-500 text-base"></i>
                  全站HTTPS加密 · 安全观影
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-refresh-line text-accent-500 text-base"></i>
                  每日定时更新 · 内容新鲜
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line text-accent-500 text-base"></i>
                  千万用户信赖 · 品质保证
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}